
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaHome, FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { FaGoogle, FaFacebookF, FaTwitter } from "react-icons/fa";
import "../../../assets/css/Buyer/dashboard/buyerauth/buyerauth.css";
import logo2 from "../../../assets/images/logo2.png";
import logo from "../../../assets/images/logo.png";
import axios from "axios";
import AppContext from "context/AppContext";
import { Spinner } from "react-bootstrap";

function BuyerLogin() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================
  const navigate = useNavigate();
  const { baseUrl, setAuthToken, setLoggedInBuyer } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // ==========================================
  // TOGGLE PASSWORD VISIBILITY
  // ==========================================
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // ==========================================
  // HANDLE FORM SUBMISSION
  // ==========================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    loginbuyer();


    // Set loading state
    setIsLoading(true);
    setErrorMessage("");

  };

  // ==========================================
  // HANDLE SOCIAL LOGIN
  // ==========================================
  const handleSocialLogin = (provider) => {
    alert(`${provider} login coming soon!`);
    // TODO: Implement social login
    // window.location.href = `/api/auth/${provider.toLowerCase()}`;

  };

  const loginbuyer = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    axios.post(`${baseUrl}/buyer/auth/login`, formData)
      .then((response) => {
        console.log(response.data);
        if (response.data.buyer == null) {
          setIsLoading(false);
          setErrorMessage("Invalid email or password");
        } else {
          console.log("********ye a rha ha buyer", response.data.buyer);
          setIsLoading(false);
          localStorage.setItem('authToken', response.data.token);
          setAuthToken(response.data.token);
          setLoggedInBuyer(response.data.buyer);
          localStorage.setItem("buyeremail", email); //global available hota ha
          localStorage.setItem("buyerPassword", password);
          localStorage.setItem("buyerId", response.data.buyer.id);
          localStorage.setItem("loggedInBuyer", JSON.stringify(response.data.buyer));
          navigate("/buyer/dashboard");
          setSuccessMessage("successfull")
        }

      }).catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }

  const buyerAlLogin = (alEmail, alPassword) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("email", alEmail);
    formData.append("password", alPassword);
    axios.post(`${baseUrl}/buyer/auth/login`, formData)
      .then((response) => {
        console.log(response.data);
        if (response.data.buyer != null) {
          setIsLoading(false);
          localStorage.setItem('authToken', response.data.token);
          setAuthToken(response.data.token);
          navigate("/buyer/dashboard");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    const alEmail = localStorage.getItem("buyeremail");
    const alPassword = localStorage.getItem("buyerPassword");
    console.log(email);
    console.log(password);
    if (alEmail != null && alEmail != "") {
      buyerAlLogin(alEmail, alPassword);
    } else {
      setIsLoading(false)
    }
  }, []);


  // ==========================================
  // RENDER COMPONENT
  // ==========================================
  return isLoading == true ? (
    <div style={{ height: "100vh" }}
      className="d-flex justify-content-center align-items-center"
    >
      <Spinner style={{ height: 80, width: 80, fontSize: 60 }} />
    </div>
  ) : (
    <div className="auth-page-container">
      <div className="auth-card">
        {/* ==========================================
            LEFT SIDE - LOGIN FORM
            ========================================== */}
        <div className="auth-form-section">
          {/* Logo */}
          <div className="auth-logo">
            <img
              src={logo2}
              alt="Estate Experts"
              className="navbar-logo"
            />
            <span>Estate Experts</span>
          </div>

          {/* Form Container */}
          <div className="auth-form-container">
            <h1 className="auth-form-title">Log In to Your Account</h1>
            <p className="auth-form-description">
              Log in to your account so you can continue building and editing your onboarding flows.
            </p>

            {/* Error Message */}
            {errorMessage && (
              <div className="auth-error-message">
                {errorMessage}
              </div>
            )}

            {/* Login Form */}
            <form
              // onSubmit={handleSubmit} 
              className="auth-form">
              {/* Email Field */}
              <div className="auth-form-group">
                <label className="auth-form-label">Email</label>
                <div className="auth-input-wrapper">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(event) => {
                      setEmail(event.target.value)
                    }}
                    placeholder="Enter your email address"
                    className="auth-form-input"
                    required
                  />
                </div>
              </div>

              {/* Password Field */}
              <div className="auth-form-group">
                <label className="auth-form-label">Password</label>
                <div className="auth-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={password}
                    onChange={(event) => {
                      setPassword(event.target.value)
                    }}
                    placeholder="Enter your password"
                    className="auth-form-input"
                    required
                  />
                  <span
                    className="auth-password-toggle"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="login-options">

                {/* <div className="remember-me">
                  <input
                    type="checkbox"
                    id="rememberMe"
                  />
                  <label htmlFor="rememberMe">
                    Remember Me
                  </label>
                </div> */}

                <Link
                  to="/buyer/forgot-password"
                  className="forgot-password"
                >
                  Forgot password
                </Link>

              </div>

              {/* Submit Button */}
              <button
                type="button"
                onClick={() => {
                  loginbuyer();
                }}
                className={`auth-submit-btn ${isLoading ? 'auth-btn-loading' : ''}`}
                disabled={isLoading}
              >
                {isLoading ? 'Logging In...' : 'LOG IN'}
              </button>
            </form>

            {/* Divider */}
            {/* <div className="auth-divider">
              <div className="auth-divider-line"></div>
              <span className="auth-divider-text">Or log in using</span>
              <div className="auth-divider-line"></div>
            </div> */}

            {/* Social Login Buttons */}
            {/* <div className="auth-social-buttons">
              <button
                className="auth-social-btn google"
                onClick={() => handleSocialLogin('Google')}
                type="button"
              >
                <FaGoogle />
              </button>
              <button
                className="auth-social-btn facebook"
                onClick={() => handleSocialLogin('Facebook')}
                type="button"
              >
                <FaFacebookF />
              </button>
              <button
                className="auth-social-btn twitter"
                onClick={() => handleSocialLogin('Twitter')}
                type="button"
              >
                <FaTwitter />
              </button>
            </div> */}
          </div>
        </div>

        {/* ==========================================
            RIGHT SIDE - PROMO SECTION
            ========================================== */}
        <div className="auth-promo-section">
          {/* Background Image */}
          <div className="auth-promo-bg"></div>

          {/* Floating Shapes */}
          <div className="auth-floating-shape auth-floating-shape-1"></div>
          <div className="auth-floating-shape auth-floating-shape-2"></div>
          <div className="auth-floating-shape auth-floating-shape-3"></div>

          {/* Content */}
          <div className="auth-promo-content">
            <img
              src={logo}
              alt="Estate Experts"
              className="navbar-logo"
            />
            <h2 className="auth-promo-title">Don't Have an Account Yet?</h2>
            <p className="auth-promo-description">
              Let's get you all set up so you can start creating your first onboarding experience.
            </p>
            <Link to="/buyer/signup" className="auth-promo-btn">
              SIGN UP
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuyerLogin;